<template>
    <div>
        <slot />
    </div>
</template>

<script>
export default {
  name: 'GuestLayout'
}
</script>

<style scoped>

</style>
